import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import noImage from '../../../../../../assets/images/no-image.png';
import { shortenStringWithTooltip, imageUrl } from '../../../../../../Components/helper';
import { hideImage, showBigImage } from '../../store/Suggestion.action';

function BomExpandView({ index, data, subBrandAccess }) {
  const { t } = useTranslation('common');

  const showStatus = (x) => {
    if (x.status === 'Approved') {
      return (
        <>
          <span>{t('TAKING_DATES.APPROVED')}</span>
          <span className="col-status right approved" />
        </>
      );
    }

    if (x.status === 'Rejected') {
      return (
        <>
          <span>{t('TAKING_DATES.REJECTED')}</span>
          <span className="col-status right rejected" />
        </>
      );
    }

    if (x.status === 'Pending' || x.status === 'pending') {
      return (
        <>
          <span>{t('TAKING_DATES.PENDING')}</span>
          <span className="col-status right pending" />
        </>
      );
    }

    if (x.status === 'Deleted') {
      return <span>{t('TAKING_DATES.DELETED')}</span>;
    }
  };
  const showType = (item) => {
    const type = item?.type?.charAt(0).toUpperCase() + item?.type?.slice(1);
    return `${type} ( BOM ) `;
  };
  return (
    <tr>
      {index !== 0 && index > 0 && (
        <>
          <td />
          <td />
          <td>
            <div className="image-detail hover-right">
              <figure onMouseOver={(e) => showBigImage(e)} onMouseLeave={() => hideImage()}>
                <div className="img-preview-inside-table sm">
                  <img width="60" alt="product img" src={data.image ? `${imageUrl}/${data?.image}` : noImage} />
                </div>
              </figure>
            </div>
          </td>

          <td className="last-fix-col">{data?.number || '--'}</td>
          <td>{data?.description ? shortenStringWithTooltip(data.description, 60) : '--'}</td>

          <td>{data?.supplierId || '--'}</td>
          <td>{data?.brandId || '--'}</td>
          {subBrandAccess && <td>{data?.subBrandId || '--'}</td>}
          <td>{data?.seasonId || '--'}</td>
          <td>{data?.month || '--'}</td>
          <td>{data?.year || '--'}</td>
          <td>{data?.catOneId || '--'}</td>
          <td>{data?.catTwoId || '--'}</td>
          <td>{data?.catThreeId || '--'}</td>
          <td>{data?.catFourId || '--'}</td>
          <td>
            {showType(data)}
            <div>{data.bomComponents[index].referenceCode}</div>
          </td>

          <td className="text-capitalize position-relative">{data.section === 'bom' && <>{showStatus(data.bomComponents[index])}</>}</td>

          <td>
            <div className="d-flex">
              <Link
                title="View"
                className="cursor-pointer text-dark text-decoration-none btn btn-action-icon mx-0"
                to={`/supplier-suggestion/detail/${data._id}/${data?.section}`}
              >
                <span className="icon-active" />
              </Link>
              <div className="info-container d-flex text-left">
                <span className="icon-info f-18" />
                <div className="info-content">
                  <p className="mb-1">
                    <b>{t('TAKING_DATES.CREATED_AT')}&nbsp;</b>
                    {moment(data?.createdAt).format('DD-MM-YYYY, h:mm a')}
                  </p>
                  <p className="mb-1">
                    <b>{t('TAKING_DATES.CREATED_BY')}&nbsp;</b>
                    {data?.createdBy}
                  </p>
                </div>
              </div>
            </div>
          </td>
        </>
      )}
    </tr>
  );
}

export default BomExpandView;
